export default __webpack_public_path__ + "static/media/Mr. Sthitaprajna Debadatta Samal.ea5143e1.png";